module.exports = __webpack_public_path__ + "static/img/syicon_0.f8d83364.svg";